import { StyleSheet } from 'aphrodite';
import { colors, combineStyles, fonts, media, mixins } from '@blend/consumer-components';

import PaneLayoutConstants from 'login-constants/paneLayoutConstants';
import * as deploymentColors from 'login-stylesheets/deploymentColors';

export const Tiempos = {
  fontFamily: ['Tiempos-Headline', 'serif'],
  fontFeatureSettings: `'kern' 1, 'liga' 1, 'clig' 1`,
  letterSpacing: 0.1,
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale',
};

// General Styles
export const horizontalPadding = '4%';
export const mediumViewHorizontalPadding = '5%';
export const smallViewTopPadding = '8%';

export const paneDefaultStyles = StyleSheet.create({
  title: {
    ...Tiempos,
    color: deploymentColors.loginBackgroundDynamicColor,
    fontSize: 34,
    lineHeight: 1.2,
    [media.smallView]: {
      fontSize: 28,
    },
  },
});

// Form styles
export const paneFormStyles = StyleSheet.create({
  container: {
    ...PaneLayoutConstants.splitContentStaticWidthMixin, // TODO UI-2685: move these styles here
    ...fonts.Roboto,
    position: 'relative',
    top: 0,
  },
  wrapper: combineStyles(PaneLayoutConstants.splitContentStaticWidthMixin, fonts.Roboto),
  sectionWrapper: {
    ':not(:last-child)': {
      paddingBottom: 35,
    },
  },
  inputsWrapper: {
    marginTop: 24,
  },
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonPadding: {
    paddingTop: 32,
  },
  buttonDisplay: {
    [media.smallView]: {
      display: 'inline-block',
    },
    [media.mediumView]: {
      display: 'inline-block',
    },
    [media.mobileMedium]: {
      width: '100%',
    },
  },
  errorWrapper: {
    paddingBottom: 20,
  },
  successText: {
    ...fonts.Roboto,
    color: colors.grass,
    transform: 'translateY(0px)',
    opacity: 0,
    position: 'absolute',
    fontSize: 14,
    lineHeight: '1.4em',
  },
  contextLink: {
    textDecoration: 'none',
  },
  loadingSpinnerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // Sticks the loading indicator in the center of the screen,
    // since the calculated header space above in the content container is 25vh
    height: '50vh',
  },
});

const translateKeyframes = {
  '0%': {
    transform: 'translateY(8px)',
    opacity: 0,
  },
  '100%': {
    transform: 'translateY(0px)',
    opacity: 1,
  },
};

export const animationStyles = StyleSheet.create({
  slideandFade: {
    ...mixins.animate(translateKeyframes, 0.4, 'initial', 'initial'),
    animationFillMode: 'forwards',
  },
});
